
import surveyForm from '~/mixins/survey-form'

export default {
    mixins: [surveyForm],
    props: {
        mode: {
            type: String,
            default: 'default',
        },
        title: {
            type: String,
            default: 'Drug Search',
        },
    },
    data () {
        return {
            form: {
                drugs: [],
                group_plan_name: null,
                state: null,
                zip_code: null,
                fips: null,
            },
        }
    },
    computed: {
        widget () {
            return this.mode === 'widget'
        },
    },
    methods: {
        onLocation ($event) {
            if ($event) {
                this.$set(this.form, 'state', $event.state)
                this.$set(this.form, 'zip_code', $event.zip_code)
                this.$set(this.form, 'fips', $event.fips)
            } else {
                this.$set(this.form, 'zip_code', null)
                this.$set(this.form, 'fips', null)
            }
        },
    }
}
